import { registerPlugin } from '@capacitor/core';

import { SignInWithGooglePlugin } from './definitions';
import { CAPACITOR_SIGN_IN_WITH_GOOGLE_PLUGIN_NAME } from '../pluginConstants';

const SignInWithGoogle = registerPlugin<SignInWithGooglePlugin>(CAPACITOR_SIGN_IN_WITH_GOOGLE_PLUGIN_NAME);

export * from './definitions';
export { SignInWithGoogle };
